import { motion } from "framer-motion";
import { Star } from "lucide-react";

const testimonials = [
  {
    name: "דניאל קליפון",
    role: "מהנדס מכונות, אגרוטק",
    quote: "הידע שצברתי במהלך הקורס מהווה לי כלי מעשי אמיתי כל DR או Brainstorm שינוי Design.\nמי שבולט הוא מי שמצליח להמחיש מהר וברור יותר. ממליץ.",
  },
  {
    name: "יצחק קונס",
    role: "מהנדס ויועץ בתחומי רובוטיקה",
    quote: "למרות שהיה לי רקע חזק בשרטוט וציור והשתמשתי בשיטה הרבה - הקורס נתן לי קווים מנחים שלא הכרתי והכניס היגיון משמעותי בתהליך העבודה.",
  },
  {
    name: "אביב דדוש",
    role: "מהנדס מכונות באלביט",
    quote: "תמיד משתמש ברישום, בפטנט יצא לי גם אבל הרוב זה סקיצות לשם המחשה ואז ישר לתוכנת CAD.",
  },
];

const TestimonialsSection = () => (
  <section className="px-6 py-16 md:py-24 bg-muted/50" dir="rtl">
    <div className="max-w-3xl mx-auto">
      <h2 className="text-foreground text-[28px] md:text-4xl font-bold text-center mb-12">
        המלצות מהשטח
      </h2>

      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.15 }}
        variants={{ hidden: {}, show: { transition: { staggerChildren: 0.12 } } }}
        className="grid grid-cols-1 md:grid-cols-3 gap-6"
      >
        {testimonials.map((t) => (
          <motion.div
            key={t.name}
            variants={{ hidden: { opacity: 0, y: 16 }, show: { opacity: 1, y: 0 } }}
            className="bg-card rounded-xl p-6 border border-border shadow-sm"
          >
            <div className="flex items-start gap-3 mb-4">
              <img src="/images/linkedin-icon.png" alt="LinkedIn" className="w-10 h-10 rounded-full shrink-0 mt-1" />
              <div className="flex-1 text-right">
                <p className="text-foreground font-bold text-lg">{t.name}</p>
                <p className="text-muted-foreground text-sm">{t.role}</p>
                <div className="flex gap-0.5 mt-1 justify-end">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 text-warning fill-current" />
                  ))}
                </div>
              </div>
            </div>
            <p className="text-foreground text-base leading-relaxed italic whitespace-pre-line">
              ״{t.quote}״
            </p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);

export default TestimonialsSection;
